import React, { useState } from 'react';
import { Check, X, ShieldCheck, Clock, BookOpen, AlertCircle, ChevronRight, Lock, XIcon, Star, RefreshCw, Gift, Download, Smartphone, Globe, CreditCard, Headphones, Pill, Brain } from 'lucide-react';
import { RecentPurchaseToast } from './components/RecentPurchaseToast';
function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60" onClick={onClose} data-id="element-0">
      <div className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[85vh] flex flex-col" onClick={e => e.stopPropagation()} data-id="element-1">
        <div className="flex items-center justify-between p-6 border-b border-gray-200" data-id="element-2">
          <h3 className="text-xl font-bold text-medical-green" data-id="element-3">{title}</h3>
          <button onClick={onClose} className="p-2 rounded-full hover:bg-gray-100 transition-colors" aria-label="Cerrar" data-id="element-4">
            <XIcon className="w-5 h-5 text-gray-500" data-id="element-5" />
          </button>
        </div>
        <div className="p-6 overflow-y-auto text-base leading-relaxed text-gray-700 space-y-4" data-id="element-6">
          {children}
        </div>
      </div>
    </div>;
}
export function App() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  const [showTierSelector, setShowTierSelector] = useState(false);
  const bookCoverUrl = 'https://cdn.magicpatterns.com/uploads/hfEB98qtYYCQobk9QVTtMz/CamScanner_3-18-26_08.17_page-0001.jpg';
  const scrollToOffer = () => {
    document.getElementById('price-card')?.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  };
  const CHECKOUT_URLS = {
    esencial: 'https://info-marketingdigital.com/checkouts/cn/hWNB46tgHMNsGpxFS7s8zUrS/es-us?_r=AQABjbsT_lWVgJK-ZAikoip6Csc8hYEJM0H0lUTHvw-gD3I&auto_redirect=false&cart_link_id=7xt0KW3q&edge_redirect=true&preview_theme_id=184565072188&skip_shop_pay=true',
    completo: 'https://info-marketingdigital.com/checkouts/cn/hWNB47Dw3T2LmwDsIqousJ0c/es-us?_r=AQABfnc9cxKIoVv9Qv9q-2XY0zj1ZzBp19mVKyqvBrY5gRI&auto_redirect=false&cart_link_id=bDjIXWbR&edge_redirect=true&preview_theme_id=184565072188&skip_shop_pay=true',
    premium: 'https://info-marketingdigital.com/checkouts/cn/hWNB47O9Y3f4nTFAgAMgNdys/es-us?_r=AQABavNwwtYIU8__n3C3PXGQ_TKO-SYqXVzv2WU9VIhojro&auto_redirect=false&cart_link_id=rCjXIumT&edge_redirect=true&preview_theme_id=184565072188&skip_shop_pay=true'
  };
  return <div className="min-h-screen flex flex-col" data-id="element-7">
      {/* URGENCY BAR */}
      <div className="bg-red-600 text-white py-3 px-4 text-center font-bold text-sm md:text-base tracking-wide animate-pulse" data-id="element-8">
        <AlertCircle className="w-4 h-4 inline-block mr-2 -mt-0.5" data-id="element-9" />
        PRECIO ESPECIAL — Desde $6.39 USD
      </div>

      {/* HERO SECTION */}
      <header className="bg-medical-green text-white pt-12 pb-20 px-4" data-id="element-10">
        <div className="max-w-3xl mx-auto text-center" data-id="element-11">
          <h1 className="text-2xl md:text-4xl font-bold leading-tight mb-8 text-yellow-300" data-id="element-12">
            ¿Sientes ardor, entumecimiento o dolor en los pies? Esto tiene
            solución.
          </h1>

          <div className="inline-block bg-red-600 text-white font-bold px-4 py-1 rounded-full text-sm tracking-wide mb-6 uppercase" data-id="element-13">
            Atención: Comunidad Hispana en USA
          </div>
          <h2 className="text-2xl md:text-4xl font-bold leading-tight mb-6" data-id="element-14">
            Protocolo SOS: La Guía Definitiva para Apagar el Ardor, Recuperar la
            Sensibilidad y Proteger tus Pies.
          </h2>
          <p className="text-xl md:text-2xl font-sans font-medium text-green-100 leading-relaxed mb-10" data-id="element-15">
            El plan de choque de 12 minutos diseñado para la comunidad hispana
            en USA que desea volver a dormir en paz y caminar sin miedo.
          </p>

          <div className="flex flex-col md:flex-row items-center justify-center gap-8 mt-12" data-id="element-16">
            <div className="w-64 md:w-80 shrink-0" data-id="element-17">
              <img src={bookCoverUrl} alt="Portada del libro Protocolo SOS" className="w-full h-auto rounded-md shadow-book border-4 border-white/10" data-id="element-18" />
            </div>
            <div className="text-left max-w-sm" data-id="element-19">
              <ul className="space-y-4 mb-8 font-sans text-lg" data-id="element-20">
                <li className="flex items-start gap-3" data-id="element-21">
                  <Check className="w-6 h-6 text-green-300 shrink-0 mt-1" data-id="element-22" />
                  <span data-id="element-23">Descarga digital inmediata</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-24">
                  <Check className="w-6 h-6 text-green-300 shrink-0 mt-1" data-id="element-25" />
                  <span data-id="element-26">Fácil de leer (letra grande)</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-27">
                  <Check className="w-6 h-6 text-green-300 shrink-0 mt-1" data-id="element-28" />
                  <span data-id="element-29">100% en Español</span>
                </li>
              </ul>
              <button onClick={() => setShowTierSelector(true)} className="w-full bg-cta-red hover:bg-cta-red-hover text-white font-bold text-xl py-4 px-6 rounded-lg shadow-lg transition-colors flex items-center justify-center gap-2" data-id="element-30">
                QUIERO MI COPIA AHORA
                <ChevronRight className="w-6 h-6" data-id="element-31" />
              </button>
              <div className="flex items-center justify-center gap-2 mt-3 text-sm text-green-200" data-id="element-32">
                <Lock className="w-4 h-4" data-id="element-33" />
                <span data-id="element-34">Pago seguro procesado por Shopify</span>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* OPENING HOOK - EMPATHY */}
      <section className="py-20 px-4 bg-cream" data-id="element-35">
        <div className="max-w-2xl mx-auto" data-id="element-36">
          <p className="font-serif text-xl md:text-2xl font-bold text-medical-green mb-8" data-id="element-37">
            Estimado amigo/a,
          </p>
          <p data-id="element-38">
            Sé lo que se siente estar sentado en el borde de la cama a las 2 de
            la mañana, frotándose los pies con desesperación, sintiendo que
            miles de alfileres calientes atraviesan la piel.
          </p>
          <p data-id="element-39">
            Sé lo que es mirar una pequeña mancha roja en el dedo gordo y sentir
            que el corazón se detiene por el miedo a la palabra{' '}
            <strong data-id="element-40">"amputación"</strong>.
          </p>
          <p data-id="element-41">
            En Estados Unidos, el sistema de salud a veces nos trata como
            números en una lista de espera. Te dan una receta, te dicen{' '}
            <em data-id="element-42">"controla tu azúcar"</em> y te mandan a casa sin herramientas
            prácticas.
          </p>
          <div className="border-l-4 border-medical-green pl-6 my-10 py-2 bg-white shadow-sm" data-id="element-43">
            <p className="mb-0 font-medium italic text-xl" data-id="element-44">
              Este protocolo nació para darte el control de nuevo.
            </p>
          </div>
        </div>
      </section>

      {/* THE PROBLEM */}
      <section className="py-20 px-4 bg-white border-y border-gray-200" data-id="element-45">
        <div className="max-w-2xl mx-auto" data-id="element-46">
          <h2 className="text-3xl md:text-4xl font-bold text-medical-green mb-8 text-center" data-id="element-47">
            La Verdad Sobre el "Ardor Nocturno"
          </h2>
          <p data-id="element-48">
            La neuropatía diabética no es solo "dolor"; es un cable pelado que
            lanza chispas en medio de la noche. El ardor estalla en cuanto las
            sábanas rozan tus pies y el hormigueo eléctrico no te deja
            descansar.
          </p>
          <p data-id="element-49">
            Muchos creen que la pérdida de sensibilidad es un camino sin
            retorno. Te han dicho que "es parte de la edad".{' '}
            <strong data-id="element-50">Mentira.</strong> El daño es serio, pero la velocidad de la
            progresión está bajo tu control.
          </p>
          <p data-id="element-51">
            Lo que intentaste antes falló porque las cremas de farmacia solo
            huelen a mentol y las pastillas solo atacan el síntoma, no la
            inflamación neural profunda ni la falta de microcirculación.
          </p>
        </div>
      </section>

      {/* THE UNIQUE MECHANISM */}
      <section className="py-20 px-4 bg-cream-dark" data-id="element-52">
        <div className="max-w-2xl mx-auto" data-id="element-53">
          <div className="flex items-center justify-center mb-6" data-id="element-54">
            <ShieldCheck className="w-16 h-16 text-medical-green" data-id="element-55" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-medical-green mb-8 text-center" data-id="element-56">
            El "Mecanismo de Enfriamiento Neural"
          </h2>
          <p data-id="element-57">
            Este libro introduce una técnica revolucionaria que utiliza la
            termodinámica controlada para{' '}
            <strong data-id="element-58">
              "resetear" los receptores de dolor en solo 12 minutos
            </strong>
            .
          </p>
          <p data-id="element-59">
            No es magia; es una estrategia de defensa científicamente
            fundamentada para que tus nervios dejen de "gritar" y recuperen su
            flujo de oxígeno vital. Es simple, seguro y puedes hacerlo desde la
            comodidad de tu hogar.
          </p>
        </div>
      </section>

      {/* WHAT YOU GET */}
      <section className="py-20 px-4 bg-white" data-id="element-60">
        <div className="max-w-3xl mx-auto" data-id="element-61">
          <h2 className="text-3xl md:text-4xl font-bold text-medical-green mb-12 text-center" data-id="element-62">
            ¿Qué vas a descubrir dentro de esta guía?
          </h2>

          <div className="space-y-8" data-id="element-63">
            <div className="flex gap-4 items-start bg-cream p-6 rounded-xl border border-gray-100" data-id="element-64">
              <Clock className="w-8 h-8 text-medical-green shrink-0 mt-1" data-id="element-65" />
              <div data-id="element-66">
                <h3 className="text-xl font-bold mb-2" data-id="element-67">
                  El Protocolo de Alivio en 12 Minutos
                </h3>
                <p className="mb-0 text-base md:text-lg" data-id="element-68">
                  Paso a paso para calmar el "incendio nocturno" antes de dormir
                  y lograr un descanso profundo.
                </p>
              </div>
            </div>

            <div className="flex gap-4 items-start bg-cream p-6 rounded-xl border border-gray-100" data-id="element-69">
              <AlertCircle className="w-8 h-8 text-medical-green shrink-0 mt-1" data-id="element-70" />
              <div data-id="element-71">
                <h3 className="text-xl font-bold mb-2" data-id="element-72">
                  El Mapa de Inspección SOS
                </h3>
                <p className="mb-0 text-base md:text-lg" data-id="element-73">
                  Cómo detectar peligros invisibles en tus pies usando la
                  técnica de la "Doble Visión".
                </p>
              </div>
            </div>

            <div className="flex gap-4 items-start bg-cream p-6 rounded-xl border border-gray-100" data-id="element-74">
              <ShieldCheck className="w-8 h-8 text-medical-green shrink-0 mt-1" data-id="element-75" />
              <div data-id="element-76">
                <h3 className="text-xl font-bold mb-2" data-id="element-77">
                  Guía de Blindaje Neural
                </h3>
                <p className="mb-0 text-base md:text-lg" data-id="element-78">
                  Qué suplementos específicos (B12, ALA, Magnesio) buscar en CVS
                  o Walgreens y cuáles son una completa estafa.
                </p>
              </div>
            </div>

            <div className="flex gap-4 items-start bg-cream p-6 rounded-xl border border-gray-100" data-id="element-79">
              <BookOpen className="w-8 h-8 text-medical-green shrink-0 mt-1" data-id="element-80" />
              <div data-id="element-81">
                <h3 className="text-xl font-bold mb-2" data-id="element-82">
                  Manual del Calzado del Sobreviviente
                </h3>
                <p className="mb-0 text-base md:text-lg" data-id="element-83">
                  Reglas de oro para comprar zapatos en USA que no muerdan tu
                  piel ni causen fricción.
                </p>
              </div>
            </div>

            <div className="flex gap-4 items-start bg-cream p-6 rounded-xl border border-gray-100" data-id="element-84">
              <Check className="w-8 h-8 text-medical-green shrink-0 mt-1" data-id="element-85" />
              <div data-id="element-86">
                <h3 className="text-xl font-bold mb-2" data-id="element-87">
                  Checklist de Dormitorio Seguro & Recursos en USA
                </h3>
                <p className="mb-0 text-base md:text-lg" data-id="element-88">
                  Cómo configurar tu cama para evitar la fricción mortal y cómo
                  pedir a Medicare tus zapatos diabéticos anuales.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* WHO IS IT FOR / NOT FOR */}
      <section className="py-20 px-4 bg-cream border-y border-gray-200" data-id="element-89">
        <div className="max-w-4xl mx-auto grid md:grid-cols-2 gap-12" data-id="element-90">
          <div className="bg-white p-8 rounded-2xl shadow-sm border-t-4 border-medical-green" data-id="element-91">
            <h3 className="text-2xl font-bold text-medical-green mb-6 flex items-center gap-2" data-id="element-92">
              <Check className="w-8 h-8" data-id="element-93" />
              ¿Para quién SÍ es esto?
            </h3>
            <ul className="space-y-4 font-sans" data-id="element-94">
              <li className="flex items-start gap-3" data-id="element-95">
                <div className="w-2 h-2 bg-medical-green rounded-full mt-2.5 shrink-0" data-id="element-96"></div>
                <span className="text-lg" data-id="element-97">
                  Personas de 50+ años con diabetes que sienten ardor o
                  pinchazos.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-98">
                <div className="w-2 h-2 bg-medical-green rounded-full mt-2.5 shrink-0" data-id="element-99"></div>
                <span className="text-lg" data-id="element-100">
                  Hispano-habitantes en USA que no encuentran respuestas claras
                  en su clínica.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-101">
                <div className="w-2 h-2 bg-medical-green rounded-full mt-2.5 shrink-0" data-id="element-102"></div>
                <span className="text-lg" data-id="element-103">
                  Hijos que cuidan a padres diabéticos y quieren prevenir una
                  úlcera grave.
                </span>
              </li>
            </ul>
          </div>

          <div className="bg-white p-8 rounded-2xl shadow-sm border-t-4 border-red-500" data-id="element-104">
            <h3 className="text-2xl font-bold text-red-600 mb-6 flex items-center gap-2" data-id="element-105">
              <X className="w-8 h-8" data-id="element-106" />
              ¿Para quién NO es?
            </h3>
            <ul className="space-y-4 font-sans" data-id="element-107">
              <li className="flex items-start gap-3" data-id="element-108">
                <div className="w-2 h-2 bg-red-500 rounded-full mt-2.5 shrink-0" data-id="element-109"></div>
                <span className="text-lg" data-id="element-110">
                  Personas que buscan curas milagrosas sin seguir instrucciones
                  diarias.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-111">
                <div className="w-2 h-2 bg-red-500 rounded-full mt-2.5 shrink-0" data-id="element-112"></div>
                <span className="text-lg" data-id="element-113">
                  Quienes no están dispuestos a dedicar 15 minutos al día a
                  revisar sus pies.
                </span>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section className="py-20 px-4 bg-white" data-id="element-114">
        <div className="max-w-2xl mx-auto text-center" data-id="element-115">
          <h2 className="text-3xl md:text-4xl font-bold text-medical-green mb-12" data-id="element-116">
            ¿Cómo Funciona?
          </h2>
          <div className="space-y-8 text-left" data-id="element-117">
            <div className="flex gap-6 items-center" data-id="element-118">
              <div className="w-12 h-12 rounded-full bg-medical-green text-white flex items-center justify-center font-bold text-xl shrink-0" data-id="element-119">
                1
              </div>
              <div data-id="element-120">
                <h4 className="font-bold text-xl" data-id="element-121">Descarga Instantánea</h4>
                <p className="mb-0 text-base" data-id="element-122">
                  Recibes el protocolo en tu email inmediatamente después del
                  pago.
                </p>
              </div>
            </div>
            <div className="flex gap-6 items-center" data-id="element-123">
              <div className="w-12 h-12 rounded-full bg-medical-green text-white flex items-center justify-center font-bold text-xl shrink-0" data-id="element-124">
                2
              </div>
              <div data-id="element-125">
                <h4 className="font-bold text-xl" data-id="element-126">Aplicación SOS</h4>
                <p className="mb-0 text-base" data-id="element-127">
                  Realizas el ciclo de contraste térmico esta misma noche.
                </p>
              </div>
            </div>
            <div className="flex gap-6 items-center" data-id="element-128">
              <div className="w-12 h-12 rounded-full bg-medical-green text-white flex items-center justify-center font-bold text-xl shrink-0" data-id="element-129">
                3
              </div>
              <div data-id="element-130">
                <h4 className="font-bold text-xl" data-id="element-131">Protección Diaria</h4>
                <p className="mb-0 text-base" data-id="element-132">
                  Usas el mapa de inspección cada mañana para vivir sin miedo.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section className="py-20 px-4 bg-cream" data-id="element-133">
        <div className="max-w-4xl mx-auto" data-id="element-134">
          <h2 className="text-3xl md:text-4xl font-bold text-medical-green mb-12 text-center" data-id="element-135">
            Lo Que Dicen Quienes Ya Lo Probaron
          </h2>
          <div className="grid md:grid-cols-3 gap-8" data-id="element-136">
            <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100" data-id="element-137">
              <div className="flex gap-1 mb-4" data-id="element-138">
                <Star className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-139" />
                <Star className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-140" />
                <Star className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-141" />
                <Star className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-142" />
                <Star className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-143" />
              </div>
              <p className="text-base leading-relaxed mb-4 italic text-gray-700" data-id="element-144">
                "Llevaba 3 años sin dormir bien por el ardor. La primera noche
                que hice el protocolo de 12 minutos, dormí 6 horas seguidas. No
                lo podía creer."
              </p>
              <div className="border-t border-gray-100 pt-4" data-id="element-145">
                <p className="font-bold text-medical-green mb-0 text-base" data-id="element-146">
                  María G.
                </p>
                <p className="text-sm text-gray-500 mb-0" data-id="element-147">
                  Houston, TX — 62 años
                </p>
              </div>
            </div>

            <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100" data-id="element-148">
              <div className="flex gap-1 mb-4" data-id="element-149">
                <Star className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-150" />
                <Star className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-151" />
                <Star className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-152" />
                <Star className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-153" />
                <Star className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-154" />
              </div>
              <p className="text-base leading-relaxed mb-4 italic text-gray-700" data-id="element-155">
                "Mi doctor solo me daba pastillas. Con esta guía aprendí a
                revisar mis pies correctamente y encontré una llaga que no había
                visto. Me salvó de algo peor."
              </p>
              <div className="border-t border-gray-100 pt-4" data-id="element-156">
                <p className="font-bold text-medical-green mb-0 text-base" data-id="element-157">
                  Roberto L.
                </p>
                <p className="text-sm text-gray-500 mb-0" data-id="element-158">
                  Los Ángeles, CA — 58 años
                </p>
              </div>
            </div>

            <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100" data-id="element-159">
              <div className="flex gap-1 mb-4" data-id="element-160">
                <Star className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-161" />
                <Star className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-162" />
                <Star className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-163" />
                <Star className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-164" />
                <Star className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-165" />
              </div>
              <p className="text-base leading-relaxed mb-4 italic text-gray-700" data-id="element-166">
                "Lo compré para mi papá. Él no usa computadora, así que se lo
                leí en voz alta. En una semana ya caminaba más seguro y el
                hormigueo bajó muchísimo."
              </p>
              <div className="border-t border-gray-100 pt-4" data-id="element-167">
                <p className="font-bold text-medical-green mb-0 text-base" data-id="element-168">
                  Carmen D.
                </p>
                <p className="text-sm text-gray-500 mb-0" data-id="element-169">
                  Miami, FL — compró para su padre de 71 años
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* GUARANTEE SECTION */}
      <section className="py-16 px-4 bg-white border-y border-gray-200" data-id="element-170">
        <div className="max-w-2xl mx-auto text-center" data-id="element-171">
          <RefreshCw className="w-16 h-16 text-medical-green mx-auto mb-6" data-id="element-172" />
          <h2 className="text-3xl md:text-4xl font-bold text-medical-green mb-4" data-id="element-173">
            Garantía de Satisfacción
          </h2>
          <p className="text-xl md:text-2xl leading-relaxed mb-2" data-id="element-174">
            Si no te ayuda, <strong data-id="element-175">te devolvemos tu dinero.</strong>
          </p>
          <p className="text-base text-gray-600" data-id="element-176">
            Prueba el Protocolo SOS sin riesgo. Si después de aplicarlo sientes
            que no te aportó valor, simplemente escríbenos y te reembolsamos el
            100% de tu compra. Sin preguntas, sin complicaciones.
          </p>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-20 px-4 bg-cream-dark" data-id="element-177">
        <div className="max-w-3xl mx-auto" data-id="element-178">
          <h2 className="text-3xl md:text-4xl font-bold text-medical-green mb-10 text-center" data-id="element-179">
            Preguntas Frecuentes
          </h2>
          <div className="space-y-6" data-id="element-180">
            <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-181">
              <h4 className="font-bold text-xl mb-2" data-id="element-182">¿Es un libro físico?</h4>
              <p className="mb-0 text-base" data-id="element-183">
                No, es una guía digital (PDF) de acceso inmediato. Podrás leerlo
                en tu celular, tablet o computadora al instante, sin esperar
                envíos.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-184">
              <h4 className="font-bold text-xl mb-2" data-id="element-185">
                ¿Necesito comprar máquinas caras?
              </h4>
              <p className="mb-0 text-base" data-id="element-186">
                No, todo lo que necesitas para el protocolo de 12 minutos está
                en tu cocina o baño.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-187">
              <h4 className="font-bold text-xl mb-2" data-id="element-188">¿Medicare cubre esto?</h4>
              <p className="mb-0 text-base" data-id="element-189">
                Este libro es una guía privada independiente, pero dentro te
                enseñamos exactamente cómo usar tus beneficios de Medicare para
                conseguir tu calzado adecuado.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* BONUSES SECTION */}
      <section id="bonuses-section" className="py-20 px-4 bg-cream" data-id="element-190">
        <div className="max-w-4xl mx-auto" data-id="element-191">
          <div className="text-center mb-12" data-id="element-192">
            <Gift className="w-14 h-14 text-medical-green mx-auto mb-4" data-id="element-193" />
            <h2 className="text-3xl md:text-4xl font-bold text-medical-green mb-4" data-id="element-194">
              3 Bonos GRATIS Incluidos con Tu Compra
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-195">
              Además del Protocolo SOS, recibirás estas 3 guías adicionales sin
              costo extra para acelerar tu recuperación.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-196">
            <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden" data-id="element-197">
              <div className="p-4 flex items-center justify-center bg-gray-50" data-id="element-198">
                <img src="https://cdn.magicpatterns.com/uploads/pHU1rVe8vSJyjnrGi5cvqS/BONO_1_.png" alt="Bono 1 - Kit SOS Rutina Diaria Anti-Úlcera" className="w-48 h-auto rounded shadow-md" data-id="element-199" />
              </div>
              <div className="p-6" data-id="element-200">
                <div className="inline-block bg-medical-green text-white text-xs font-bold px-3 py-1 rounded-full mb-3 uppercase tracking-wide" data-id="element-201">
                  Bono 1 — Gratis
                </div>
                <h3 className="text-lg font-bold mb-2" data-id="element-202">
                  Kit SOS de Rutina Diaria Anti-Úlcera (AM/PM)
                </h3>
                <p className="text-sm text-gray-600 mb-0" data-id="element-203">
                  Checklist + tarjeta SOS + registro semanal para proteger tus
                  pies cada día.
                </p>
              </div>
            </div>

            <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden" data-id="element-204">
              <div className="p-4 flex items-center justify-center bg-gray-50" data-id="element-205">
                <img src="https://cdn.magicpatterns.com/uploads/xz6XhGKJdP4DvEPcMxetnm/BONO_2_.png" alt="Bono 2 - Scripts de Consulta Podólogo/Endo" className="w-48 h-auto rounded shadow-md" data-id="element-206" />
              </div>
              <div className="p-6" data-id="element-207">
                <div className="inline-block bg-medical-green text-white text-xs font-bold px-3 py-1 rounded-full mb-3 uppercase tracking-wide" data-id="element-208">
                  Bono 2 — Gratis
                </div>
                <h3 className="text-lg font-bold mb-2" data-id="element-209">
                  Scripts de Consulta Podólogo/Endo
                </h3>
                <p className="text-sm text-gray-600 mb-0" data-id="element-210">
                  Lo que decir (y qué pedir) en 7 minutos. Incluye plantillas +
                  preguntas clave + glosario.
                </p>
              </div>
            </div>

            <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden" data-id="element-211">
              <div className="p-4 flex items-center justify-center bg-gray-50" data-id="element-212">
                <img src="https://cdn.magicpatterns.com/uploads/q9FEKc3JehrNFZsRX6dysP/BONO_3_.png" alt="Bono 3 - Plan Casa a Prueba de Pie Diabético" className="w-48 h-auto rounded shadow-md" data-id="element-213" />
              </div>
              <div className="p-6" data-id="element-214">
                <div className="inline-block bg-medical-green text-white text-xs font-bold px-3 py-1 rounded-full mb-3 uppercase tracking-wide" data-id="element-215">
                  Bono 3 — Gratis
                </div>
                <h3 className="text-lg font-bold mb-2" data-id="element-216">
                  Plan "Casa a Prueba de Pie Diabético"
                </h3>
                <p className="text-sm text-gray-600 mb-0" data-id="element-217">
                  Auditoría Express en 15 minutos. Guía profesional para la
                  seguridad del hogar.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* OFFER & CTA */}
      <section id="offer-section" className="py-24 px-4 bg-medical-green text-white" data-id="element-218">
        <div className="max-w-6xl mx-auto text-center" data-id="element-219">
          <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-220">
            Recupera tu tranquilidad y protege tus pasos
          </h2>
          <p className="text-xl md:text-2xl text-green-100 mb-12" data-id="element-221">
            Por una inversión única, sin suscripciones ni cobros ocultos.
          </p>

          <div className="grid md:grid-cols-3 gap-8 items-stretch mb-12 text-left" data-id="element-222">
            {/* TIER 1: ESENCIAL */}
            <div className="bg-white text-text-dark p-6 md:p-8 rounded-2xl shadow-xl flex flex-col relative" data-id="element-223">
              <div className="text-center mb-6" data-id="element-224">
                <div className="inline-block bg-gray-200 text-gray-700 font-bold px-3 py-1 rounded-full text-sm uppercase tracking-wider mb-4" data-id="element-225">
                  Esencial
                </div>
                <img src={bookCoverUrl} alt="Protocolo SOS" className="w-24 mx-auto mb-4 shadow-book" data-id="element-226" />
                <div className="text-4xl font-bold text-medical-green mb-1" data-id="element-227">
                  $6.39{' '}
                  <span className="text-lg text-gray-500 font-normal" data-id="element-228">USD</span>
                </div>
              </div>

              <div className="space-y-3 mb-8 flex-1" data-id="element-229">
                <div className="flex items-start gap-2" data-id="element-230">
                  <Check className="w-5 h-5 text-green-500 shrink-0 mt-0.5" data-id="element-231" />
                  <span className="text-sm font-medium" data-id="element-232">
                    Protocolo SOS: Neuropatía y Pie Diabética (PDF)
                  </span>
                </div>
                <div className="flex items-start gap-2" data-id="element-233">
                  <Check className="w-5 h-5 text-green-500 shrink-0 mt-0.5" data-id="element-234" />
                  <span className="text-sm" data-id="element-235">
                    Bono 1: Kit SOS Rutina Diaria Anti-Úlcera
                  </span>
                </div>
                <div className="flex items-start gap-2" data-id="element-236">
                  <Check className="w-5 h-5 text-green-500 shrink-0 mt-0.5" data-id="element-237" />
                  <span className="text-sm" data-id="element-238">
                    Bono 2: Scripts de Consulta Podólogo/Endo
                  </span>
                </div>
                <div className="flex items-start gap-2" data-id="element-239">
                  <Check className="w-5 h-5 text-green-500 shrink-0 mt-0.5" data-id="element-240" />
                  <span className="text-sm" data-id="element-241">
                    Bono 3: Plan Casa a Prueba de Pie Diabético
                  </span>
                </div>
              </div>

              <a href="https://info-marketingdigital.com/checkouts/cn/hWNB46tgHMNsGpxFS7s8zUrS/es-us?_r=AQABjbsT_lWVgJK-ZAikoip6Csc8hYEJM0H0lUTHvw-gD3I&auto_redirect=false&cart_link_id=7xt0KW3q&edge_redirect=true&preview_theme_id=184565072188&skip_shop_pay=true" target="_blank" rel="noopener noreferrer" className="w-full bg-cta-red hover:bg-cta-red-hover text-white font-bold text-lg py-4 px-4 rounded-xl shadow-lg transition-transform hover:scale-[1.02] active:scale-95 flex items-center justify-center text-center leading-tight no-underline mt-auto" data-id="element-242">
                QUIERO EL PACK ESENCIAL — $6.39
              </a>
            </div>

            {/* TIER 2: COMPLETO (MOST POPULAR) */}
            <div id="price-card" className="bg-white text-text-dark p-6 md:p-8 rounded-2xl shadow-2xl border-4 border-yellow-400 transform md:scale-105 flex flex-col relative z-10" data-id="element-243">
              <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-yellow-400 text-yellow-900 font-bold px-4 py-1 rounded-full text-sm uppercase tracking-wider shadow-md whitespace-nowrap" data-id="element-244">
                Más Popular
              </div>
              <div className="text-center mb-6 mt-2" data-id="element-245">
                <div className="inline-block bg-medical-green/10 text-medical-green font-bold px-3 py-1 rounded-full text-sm uppercase tracking-wider mb-4" data-id="element-246">
                  Completo
                </div>
                <img src={bookCoverUrl} alt="Protocolo SOS" className="w-28 mx-auto mb-4 shadow-book" data-id="element-247" />
                <div className="text-5xl font-bold text-medical-green mb-1" data-id="element-248">
                  $15.39{' '}
                  <span className="text-xl text-gray-500 font-normal" data-id="element-249">USD</span>
                </div>
              </div>

              <div className="space-y-3 mb-8 flex-1" data-id="element-250">
                <div className="flex items-start gap-2" data-id="element-251">
                  <Check className="w-5 h-5 text-green-500 shrink-0 mt-0.5" data-id="element-252" />
                  <span className="text-sm font-medium" data-id="element-253">
                    Todo lo del Pack Esencial
                  </span>
                </div>
                <div className="flex items-start gap-2 bg-yellow-50 p-2 rounded-lg border border-yellow-100" data-id="element-254">
                  <Check className="w-5 h-5 text-green-500 shrink-0 mt-1.5" data-id="element-255" />
                  <img src="https://cdn.magicpatterns.com/uploads/wfxEHu9PJaYeNPf63LqtBK/ORDEN_BUMPS_1.png" alt="Semáforo del Calzado" className="w-8 h-8 rounded object-cover shrink-0" data-id="element-256" />
                  <span className="text-sm font-medium text-yellow-900" data-id="element-257">
                    El Semáforo del Calzado
                  </span>
                </div>
                <div className="flex items-start gap-2 bg-yellow-50 p-2 rounded-lg border border-yellow-100" data-id="element-258">
                  <Check className="w-5 h-5 text-green-500 shrink-0 mt-1.5" data-id="element-259" />
                  <img src="https://cdn.magicpatterns.com/uploads/75uU8ZxPDrCpqu2EJg7jkF/ORDEN_BUMPS_2.png" alt="Cocina Neural" className="w-8 h-8 rounded object-cover shrink-0" data-id="element-260" />
                  <span className="text-sm font-medium text-yellow-900" data-id="element-261">
                    Cocina Neural: 7 Días de Cenas 'Apaga-Fuego'
                  </span>
                </div>
              </div>

              <a href="https://info-marketingdigital.com/checkouts/cn/hWNB47Dw3T2LmwDsIqousJ0c/es-us?_r=AQABfnc9cxKIoVv9Qv9q-2XY0zj1ZzBp19mVKyqvBrY5gRI&auto_redirect=false&cart_link_id=bDjIXWbR&edge_redirect=true&preview_theme_id=184565072188&skip_shop_pay=true" target="_blank" rel="noopener noreferrer" className="w-full bg-cta-red hover:bg-cta-red-hover text-white font-bold text-xl py-5 px-4 rounded-xl shadow-lg transition-transform hover:scale-[1.02] active:scale-95 flex items-center justify-center text-center leading-tight no-underline mt-auto" data-id="element-262">
                QUIERO EL PACK COMPLETO — $15.39
              </a>
            </div>

            {/* TIER 3: PREMIUM */}
            <div className="bg-white text-text-dark p-6 md:p-8 rounded-2xl shadow-xl border-t-4 border-yellow-600 flex flex-col relative" data-id="element-263">
              <div className="text-center mb-6" data-id="element-264">
                <div className="inline-block bg-yellow-100 text-yellow-800 font-bold px-3 py-1 rounded-full text-sm uppercase tracking-wider mb-4" data-id="element-265">
                  Premium
                </div>
                <img src={bookCoverUrl} alt="Protocolo SOS" className="w-24 mx-auto mb-4 shadow-book" data-id="element-266" />
                <div className="text-4xl font-bold text-medical-green mb-1" data-id="element-267">
                  $24.39{' '}
                  <span className="text-lg text-gray-500 font-normal" data-id="element-268">USD</span>
                </div>
              </div>

              <div className="space-y-3 mb-8 flex-1" data-id="element-269">
                <div className="flex items-start gap-2" data-id="element-270">
                  <Check className="w-5 h-5 text-green-500 shrink-0 mt-0.5" data-id="element-271" />
                  <span className="text-sm font-medium" data-id="element-272">
                    Todo lo del Pack Completo
                  </span>
                </div>
                <div className="flex items-start gap-2 bg-gray-50 p-2 rounded-lg" data-id="element-273">
                  <Check className="w-5 h-5 text-green-500 shrink-0 mt-1" data-id="element-274" />
                  <Pill className="w-6 h-6 text-medical-green shrink-0" data-id="element-275" />
                  <span className="text-sm font-medium" data-id="element-276">
                    Protocolo de Regeneración 90 Días
                  </span>
                </div>
                <div className="flex items-start gap-2 bg-gray-50 p-2 rounded-lg" data-id="element-277">
                  <Check className="w-5 h-5 text-green-500 shrink-0 mt-1" data-id="element-278" />
                  <Brain className="w-6 h-6 text-medical-green shrink-0" data-id="element-279" />
                  <span className="text-sm font-medium" data-id="element-280">
                    Círculo de Cuidado Gold
                  </span>
                </div>
              </div>

              <a href="https://info-marketingdigital.com/checkouts/cn/hWNB47O9Y3f4nTFAgAMgNdys/es-us?_r=AQABavNwwtYIU8__n3C3PXGQ_TKO-SYqXVzv2WU9VIhojro&auto_redirect=false&cart_link_id=rCjXIumT&edge_redirect=true&preview_theme_id=184565072188&skip_shop_pay=true" target="_blank" rel="noopener noreferrer" className="w-full bg-cta-red hover:bg-cta-red-hover text-white font-bold text-lg py-4 px-4 rounded-xl shadow-lg transition-transform hover:scale-[1.02] active:scale-95 flex items-center justify-center text-center leading-tight no-underline mt-auto" data-id="element-281">
                QUIERO EL PACK PREMIUM — $24.39
              </a>
            </div>
          </div>

          {/* Trust Indicators */}
          <div className="max-w-4xl mx-auto bg-white/10 p-6 md:p-8 rounded-2xl backdrop-blur-sm border border-white/20" data-id="element-282">
            <p className="text-sm text-green-100 mb-6 font-medium text-center" data-id="element-283">
              Acceso inmediato tras la compra. Descarga en PDF. Tu pago es 100%
              seguro.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 text-left text-sm text-white" data-id="element-284">
              <div className="flex items-start gap-3" data-id="element-285">
                <Download className="w-5 h-5 text-green-300 shrink-0 mt-0.5" data-id="element-286" />
                <span data-id="element-287">Descarga instantánea — disponible en segundos</span>
              </div>
              <div className="flex items-start gap-3" data-id="element-288">
                <Smartphone className="w-5 h-5 text-green-300 shrink-0 mt-0.5" data-id="element-289" />
                <span data-id="element-290">Compatible con celular, tablet y computadora</span>
              </div>
              <div className="flex items-start gap-3" data-id="element-291">
                <Globe className="w-5 h-5 text-green-300 shrink-0 mt-0.5" data-id="element-292" />
                <span data-id="element-293">
                  En español — diseñado para la comunidad hispana en USA
                </span>
              </div>
              <div className="flex items-start gap-3" data-id="element-294">
                <CreditCard className="w-5 h-5 text-green-300 shrink-0 mt-0.5" data-id="element-295" />
                <span data-id="element-296">Sin suscripciones — pagas una sola vez</span>
              </div>
              <div className="flex items-start gap-3 lg:col-span-2" data-id="element-297">
                <Headphones className="w-5 h-5 text-green-300 shrink-0 mt-0.5" data-id="element-298" />
                <span data-id="element-299">
                  Si tienes problemas con tu descarga, te respondemos en menos
                  de 24 horas
                </span>
              </div>
            </div>
            <div className="mt-6 pt-6 border-t border-white/20 text-center" data-id="element-300">
              <p className="text-xs text-green-200 italic mb-0" data-id="element-301">
                Los bonos son parte de esta oferta de lanzamiento. No hay
                garantía de que estén disponibles mañana al mismo precio.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="bg-gray-900 text-gray-400 py-8 text-center px-4" data-id="element-302">
        <div className="max-w-2xl mx-auto text-sm" data-id="element-303">
          <p className="mb-4" data-id="element-304">
            Descargo de responsabilidad: Este material es solo para fines
            informativos y educativos. No sustituye el consejo médico
            profesional, diagnóstico o tratamiento. Siempre busque el consejo de
            su médico u otro proveedor de salud calificado con cualquier
            pregunta que pueda tener sobre una condición médica.
          </p>
          <div className="flex items-center justify-center gap-4 mb-4" data-id="element-305">
            <button onClick={() => setShowPrivacy(true)} className="underline hover:text-white transition-colors" data-id="element-306">
              Política de Privacidad
            </button>
            <span className="text-gray-600" data-id="element-307">|</span>
            <button onClick={() => setShowTerms(true)} className="underline hover:text-white transition-colors" data-id="element-308">
              Términos y Condiciones
            </button>
          </div>
          <p data-id="element-309">
            &copy; {new Date().getFullYear()} Protocolo SOS. Todos los derechos
            reservados.
          </p>
        </div>
      </footer>

      {/* PRIVACY POLICY MODAL */}
      <LegalModal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} title="Política de Privacidad" data-id="element-310">
        <p data-id="element-311">
          <strong data-id="element-312">Última actualización:</strong> Enero 2025
        </p>
        <p data-id="element-313">
          En Protocolo SOS, respetamos su privacidad y nos comprometemos a
          proteger la información personal que usted nos proporciona.
        </p>
        <p data-id="element-314">
          <strong data-id="element-315">Información que recopilamos:</strong> Cuando realiza una
          compra, recopilamos su nombre, dirección de correo electrónico y datos
          de pago necesarios para procesar su transacción. Los pagos son
          procesados de forma segura a través de Shopify y nosotros no
          almacenamos información de tarjetas de crédito.
        </p>
        <p data-id="element-316">
          <strong data-id="element-317">Uso de la información:</strong> Utilizamos su información
          únicamente para entregar el producto digital adquirido a su correo
          electrónico y para enviar comunicaciones relacionadas con su compra.
        </p>
        <p data-id="element-318">
          <strong data-id="element-319">Compartir información:</strong> No vendemos, intercambiamos ni
          transferimos su información personal a terceros. La única excepción
          son los proveedores de servicios de confianza que nos ayudan a operar
          nuestro sitio web y procesar pagos (como Shopify).
        </p>
        <p data-id="element-320">
          <strong data-id="element-321">Cookies:</strong> Nuestro sitio puede utilizar cookies para
          mejorar su experiencia de navegación. Puede desactivar las cookies en
          la configuración de su navegador.
        </p>
        <p data-id="element-322">
          <strong data-id="element-323">Sus derechos:</strong> Usted tiene derecho a solicitar acceso,
          corrección o eliminación de sus datos personales en cualquier momento.
        </p>
        <p data-id="element-324">
          <strong data-id="element-325">Seguridad:</strong> Implementamos medidas de seguridad
          estándar de la industria para proteger su información personal.
        </p>
      </LegalModal>

      {/* TERMS MODAL */}
      <LegalModal isOpen={showTerms} onClose={() => setShowTerms(false)} title="Términos y Condiciones" data-id="element-326">
        <p data-id="element-327">
          <strong data-id="element-328">Última actualización:</strong> Enero 2025
        </p>
        <p data-id="element-329">
          Al acceder y utilizar este sitio web y adquirir el producto "Protocolo
          SOS", usted acepta los siguientes términos y condiciones.
        </p>
        <p data-id="element-330">
          <strong data-id="element-331">Naturaleza del producto:</strong> Protocolo SOS es un producto
          digital informativo y educativo en formato PDF. No constituye consejo
          médico profesional, diagnóstico ni tratamiento. Siempre consulte a su
          médico antes de iniciar cualquier programa de salud.
        </p>
        <p data-id="element-332">
          <strong data-id="element-333">Entrega del producto:</strong> Tras completar su compra,
          recibirá un enlace de descarga en su correo electrónico de forma
          inmediata. Es su responsabilidad proporcionar una dirección de correo
          electrónico válida.
        </p>
        <p data-id="element-334">
          <strong data-id="element-335">Política de reembolso:</strong> Debido a la naturaleza digital
          del producto, todas las ventas son finales. Si experimenta problemas
          técnicos con la descarga, nuestro equipo le asistirá para resolver el
          inconveniente.
        </p>
        <p data-id="element-336">
          <strong data-id="element-337">Propiedad intelectual:</strong> Todo el contenido del
          Protocolo SOS está protegido por derechos de autor. Queda prohibida su
          reproducción, distribución o reventa sin autorización expresa.
        </p>
        <p data-id="element-338">
          <strong data-id="element-339">Limitación de responsabilidad:</strong> Los resultados pueden
          variar de persona a persona. No garantizamos resultados específicos.
          El uso de la información contenida en esta guía es bajo su propia
          responsabilidad.
        </p>
        <p data-id="element-340">
          <strong data-id="element-341">Modificaciones:</strong> Nos reservamos el derecho de
          modificar estos términos en cualquier momento. Las modificaciones
          serán efectivas inmediatamente después de su publicación en el sitio.
        </p>
      </LegalModal>

      {/* TIER SELECTOR MODAL */}
      {showTierSelector && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60" onClick={() => setShowTierSelector(false)} data-id="element-342">
          <div className="bg-white rounded-2xl shadow-2xl max-w-lg w-full overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-343">
            <div className="bg-medical-green p-5 text-white text-center relative" data-id="element-344">
              <h3 className="text-xl font-bold mb-1" data-id="element-345">Elige tu pack</h3>
              <p className="text-sm text-green-200 mb-0" data-id="element-346">
                Todos incluyen acceso inmediato en PDF
              </p>
              <button onClick={() => setShowTierSelector(false)} className="absolute top-3 right-3 p-1.5 rounded-full hover:bg-white/20 transition-colors" aria-label="Cerrar" data-id="element-347">
                <XIcon className="w-5 h-5 text-white" data-id="element-348" />
              </button>
            </div>

            <div className="p-4 space-y-3" data-id="element-349">
              {/* Option 1: Esencial */}
              <a href={CHECKOUT_URLS.esencial} target="_blank" rel="noopener noreferrer" className="flex items-center gap-4 p-4 rounded-xl border-2 border-gray-200 hover:border-medical-green hover:bg-green-50 transition-all no-underline group" data-id="element-350">
                <div className="flex-1" data-id="element-351">
                  <div className="flex items-center gap-2 mb-1" data-id="element-352">
                    <span className="bg-gray-200 text-gray-700 font-bold px-2 py-0.5 rounded-full text-xs uppercase" data-id="element-353">
                      Esencial
                    </span>
                  </div>
                  <p className="text-sm text-gray-600 mb-0" data-id="element-354">
                    PDF + 3 Bonos gratis
                  </p>
                </div>
                <div className="text-right shrink-0" data-id="element-355">
                  <div className="text-2xl font-bold text-medical-green" data-id="element-356">
                    $6.39
                  </div>
                  <span className="text-xs text-gray-500" data-id="element-357">USD</span>
                </div>
                <ChevronRight className="w-5 h-5 text-gray-400 group-hover:text-medical-green shrink-0" data-id="element-358" />
              </a>

              {/* Option 2: Completo (recommended) */}
              <a href={CHECKOUT_URLS.completo} target="_blank" rel="noopener noreferrer" className="flex items-center gap-4 p-4 rounded-xl border-2 border-yellow-400 bg-yellow-50 hover:bg-yellow-100 transition-all no-underline group relative" data-id="element-359">
                <div className="absolute -top-2.5 left-4 bg-yellow-400 text-yellow-900 font-bold px-2 py-0.5 rounded-full text-[10px] uppercase tracking-wider" data-id="element-360">
                  Recomendado
                </div>
                <div className="flex-1 mt-1" data-id="element-361">
                  <div className="flex items-center gap-2 mb-1" data-id="element-362">
                    <span className="bg-medical-green/10 text-medical-green font-bold px-2 py-0.5 rounded-full text-xs uppercase" data-id="element-363">
                      Completo
                    </span>
                  </div>
                  <p className="text-sm text-gray-700 mb-0" data-id="element-364">
                    PDF + 3 Bonos + 2 Guías extra
                  </p>
                </div>
                <div className="text-right shrink-0" data-id="element-365">
                  <div className="text-2xl font-bold text-medical-green" data-id="element-366">
                    $15.39
                  </div>
                  <span className="text-xs text-gray-500" data-id="element-367">USD</span>
                </div>
                <ChevronRight className="w-5 h-5 text-yellow-600 group-hover:text-medical-green shrink-0" data-id="element-368" />
              </a>

              {/* Option 3: Premium */}
              <a href={CHECKOUT_URLS.premium} target="_blank" rel="noopener noreferrer" className="flex items-center gap-4 p-4 rounded-xl border-2 border-yellow-600/30 hover:border-yellow-600 hover:bg-yellow-50 transition-all no-underline group" data-id="element-369">
                <div className="flex-1" data-id="element-370">
                  <div className="flex items-center gap-2 mb-1" data-id="element-371">
                    <span className="bg-yellow-100 text-yellow-800 font-bold px-2 py-0.5 rounded-full text-xs uppercase" data-id="element-372">
                      Premium
                    </span>
                  </div>
                  <p className="text-sm text-gray-600 mb-0" data-id="element-373">
                    Todo incluido + 2 Upsells exclusivos
                  </p>
                </div>
                <div className="text-right shrink-0" data-id="element-374">
                  <div className="text-2xl font-bold text-medical-green" data-id="element-375">
                    $24.39
                  </div>
                  <span className="text-xs text-gray-500" data-id="element-376">USD</span>
                </div>
                <ChevronRight className="w-5 h-5 text-gray-400 group-hover:text-yellow-700 shrink-0" data-id="element-377" />
              </a>
            </div>

            <div className="px-4 pb-4" data-id="element-378">
              <div className="flex items-center justify-center gap-2 text-xs text-gray-400 pt-2 border-t border-gray-100" data-id="element-379">
                <Lock className="w-3 h-3" data-id="element-380" />
                <span data-id="element-381">Pago 100% seguro procesado por Shopify</span>
              </div>
            </div>
          </div>
        </div>}

      <RecentPurchaseToast data-id="element-382" />
    </div>;
}